<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  @let vm = offshoreReportStore.vm();

  <nsp-calendar-input
    name="observationTime"
    id="observationTime"
    label="Observation Time"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'observationTime')"
    [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'observationTime')"
    [value]="positionAndWeatherStore.observation().observationTime.value"
    [ngModel]="positionAndWeatherStore.observation().observationTime.value"
  />
  <nsp-select-input
    name="observationTimezone"
    id="observationTimezone"
    label="Observation Timezone"
    [options]="timezoneOptions"
    [labelWidthPercentage]="33"
    [required]="vm.isFieldRequired(tabId, sectionId, 'observationTimezone')"
    [value]="positionAndWeatherStore.observation().observationTimezone.value"
    [ngModel]="positionAndWeatherStore.observation().observationTimezone.value"
  />
</form>
